import { Injectable } from '@angular/core';

declare var $: any;

@Injectable()
export class VMsg_zh_TW {
static load() {

/*
 * Translated default messages for the jQuery validation plugin.
 * Region: TW (Taiwan)
 */
$.extend( $.validator.messages, {
	required: "必須填寫",
	remote: "請修正此欄位",
	email: "請輸入有效的電子郵件",
	url: "請輸入有效的網址",
	date: "請輸入有效的日期",
	dateISO: "請輸入有效的日期 (YYYY-MM-DD)",
	number: "請輸入正確的數值",
	digits: "只可輸入數字",
	creditcard: "請輸入有效的信用卡號碼",
	equalTo: "請重複輸入一次",
	extension: "請輸入有效的後綴",
	maxlength: $.validator.format( "最多 {0} 個字" ),
	minlength: $.validator.format( "最少 {0} 個字" ),
	rangelength: $.validator.format( "請輸入長度為 {0} 至 {1} 之間的字串" ),
	range: $.validator.format( "請輸入 {0} 至 {1} 之間的數值" ),
	max: $.validator.format( "請輸入不大於 {0} 的數值" ),
	min: $.validator.format( "請輸入不小於 {0} 的數值" ),
	step: $.validator.format( "請輸入{0}整數倍的數值" ),
	accept: "請選擇有效後綴的文件",
	alphanumeric: "只能輸入英文字符數字下劃線",
	integer: "請輸入整數",
	ipv4: "請輸入有效的IPv4地址",
	ipv6: "請輸入有效的IPv6地址",
	lettersonly: "只能輸入英文字符",
	letterswithbasicpunc: "只能輸入英文字符和符號",
	notEqualTo: "你的輸入相同",
	nowhitespace: "不能輸入空白字符",
	pattern: $.validator.format( "無效格式 ({0})" ),
	time: "請輸入有效的時間",
	url2: "請輸入有效的網址",
	minbytelength: $.validator.format( "最少 {0} 個半角長度" ),
	maxByteLength: $.validator.format( "最多 {0} 個半角長度" ),
	rangeByteLength: $.validator.format( "請輸入長度為 {0} 至 {1} 之間的半角長度" ),
	halfWidth: "請輸入半角字符",
	fullWidth: "請輸入全角字符",
	kanji: "請輸入半角漢字",
	kana: "請輸入假名",
	hiragana: "請輸入平假名",
	katakana: "請輸入片假名",
	halfKatakana: "請輸入半角片假名",
	fullKatakana: "請輸入全角片假名",
	date_yyyyMMdd: "請輸入有效的日期 (yyyyMMdd)",
	date_yyyy_MM_dd: "請輸入有效的日期 (yyyy/MM/dd)",
	date_yyyy_MM: "請輸入有效的年月 (yyyy/MM)",
	date_yyyyMM: "請輸入有效的年月 (yyyyMM)",
	date_MM_dd: "請輸入有效的日期 (MM/dd)",
	date_MMdd: "請輸入有效的日期 (MMdd)",
	time_HH_mm: "請輸入有效的時間 (HH:mm)",
	time_HH_mm_ss: "請輸入有效的時間 (HH:mm:ss)",
	time_HHmmss: "請輸入有效的時間 (HHmmss)",
	phoneJP: "請輸入有效的電話號碼",
	mobileJP: "請輸入有效的手機號碼",
	numberLessThen: "請輸入相比較小些的數",
	numberLessEqualTo: "請輸入相比較相同或小些的數",
	dateLessThen: "請輸入相比較早些的時間",
	dateLessEqualTo: "請輸入相比較相同或早些的時間",
	pwd: "請輸入數字,英文字符和符號[@#$%]。三種都不可少"
} );
}
}


// WEBPACK FOOTER //
// C:/wxj/LicAuth/05開発/LicAuth.angularjs/src/app/resources/validate_zh-TW.ts